import React from "react";
import { withRouteData } from "react-static";
import { withNamespaces } from "react-i18next";

const FACEBOOK_PAGE_URL = `https://m.me/${process.env.REACT_APP_FACEBOOK_PAGE_ID}`;

const SmallMenu = props => {
  const { t, goTo, currentLang, setLanguage } = props;

  return (
    <ul className="main-nav" id="menu">
      <li
        style={{
          marginRight: "40px",
          paddingTop: "8px",
          borderTop: "1px solid rgba(255, 255, 255, 0.2)"
        }}
        onClick={() => goTo("/legal")}
      >
        <a href="/legal" className="nav-links">
          {t("legal")}
        </a>
      </li>

      <li
        onClick={() => {
          window.location.href = FACEBOOK_PAGE_URL;
        }}
        style={{ marginRight: "40px" }}
      >
        <a href={FACEBOOK_PAGE_URL} className="nav-links">
          {t("contact")}
        </a>
      </li>
      <li
        style={{ marginLeft: "40px", marginRight: "40px" }}
        onClick={() => setLanguage("fr")}
      >
        <a
          style={{
            color: currentLang.startsWith("fr") ? "#72ce07" : "white"
          }}
        >
          <span>{t("language.fr")}</span>
        </a>
      </li>
      <li
        style={{ marginLeft: "40px", marginRight: "40px" }}
        onClick={() => setLanguage("en")}
      >
        <a
          style={{ color: currentLang.startsWith("en") ? "#72ce07" : "white" }}
        >
          <span>{t("language.en")}</span>
        </a>
      </li>
    </ul>
  );
};

export default withNamespaces("translation")(withRouteData(SmallMenu));



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/components/navBar/small-screen-menu.js